import React from 'react'
import { Translate } from 'react-localize-redux'
import { Avatar, Box, Card, makeStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import Rating from '@material-ui/lab/Rating'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import BallIcon from 'assets/images/ballicon.svg'
import { formateDate } from 'utils/formatDate'
import { SubLink } from 'containers'
import { withRouter } from 'react-router-dom'
import useTeamFeature from 'hooks/useTeamFeature'
import PropTypes from 'prop-types'
import PlayerEditDialog from './PlayerEditDialog'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  AvatarWrap: {
    width: 140,
    borderRadius: 70,
    margin: theme.spacing(0, 'auto'),
    position: 'relative',
    padding: theme.spacing(0.3),
  },
  AvatarImage: {
    width: 140,
    height: 140,
  },
  AvatarEditIcon: {
    position: 'absolute',
    top: 0,
    right: -60,
  },
  wrapper: {
    height: '100%',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}))

const PlayerSummary = ({ player, updatePlayer }) => {
  const [open, setOpen] = React.useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const { first_name: firstName, last_name: lastName, avatar } = player

  const classes = useStyles()

  return (
    <Card component={Box} p={3} className={classes.wrapper}>
      {open && (
        <PlayerEditDialog
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
          initialValues={player}
          updatePlayer={updatePlayer}
          isPlayerDashboard
        />
      )}
      <Box className={classes.AvatarWrap}>
        <IconButton onClick={handleOpen} className={classes.AvatarEditIcon}>
          <EditIcon fontSize="small" />
        </IconButton>
        <Avatar
          alt="logo"
          src={avatar && avatar.full_url ? avatar.full_url : BallIcon}
          className={classes.AvatarImage}
        />
      </Box>
      <div className={classes.textWrapper}>
        <Typography variant="h4" component="h4">
          {firstName} {lastName}{' '}
        </Typography>
      </div>
    </Card>
  )
}
PlayerSummary.propTypes = {
  player: PropTypes.shape({
    id: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    avatar: PropTypes.shape({
      full_url: PropTypes.string,
    }),
  }).isRequired,
  updatePlayer: PropTypes.func.isRequired,
}

export default withRouter(PlayerSummary)
